<template lang="pug">
	#app
		transition(name="fadeLoading")
			Loading(v-show="isActiveLoading" :isActiveLoading.sync="isActiveLoading")
		Header
		keep-alive
			router-view(:isActiveList.sync="isActiveList" :isActiveRule.sync="isActiveRule" :isActiveLoading.sync="isActiveLoading")
		List(:isActiveList.sync="isActiveList")
		Rule(:isActiveRule.sync="isActiveRule")
</template>

<script>
import Loading from "@/components/Loading";
import Header from "@/components/Header";
import List from "@/components/List";
import Rule from "@/components/Rule";

import VConsole from "vconsole";
if (process.env.NODE_ENV === "development") {
	const vConsole = new VConsole({ theme: "dark" });
	console.log(vConsole);
}

export default {
	name: "App",
	data() {
		return {
			isActiveLoading: true,
			isActiveRule: false,
			isActiveList: false,
		};
	},
	components: {
		Loading,
		Header,
		List,
		Rule,
	},
	mounted() {
		let _this = this;
		_this.$nextTick(function () {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		});
	},
};
</script>

<style lang="sass">
@use "@/assets/sass/_reset.sass"
@use "@/assets/sass/_layout.sass"
</style>
